var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b,.c{fill:none;}.b,.c{stroke:#3063d5;stroke-width:1.5px;}.c{stroke-linecap:round;}.d{stroke:none;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 32,
    height: 32
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(7 7)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    cx: 9,
    cy: 9,
    r: 9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 9,
    cy: 9,
    r: 8.25
  })), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 6,
    transform: "translate(6 9)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 6.749,
    transform: "translate(9 5.626) rotate(90)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoAdd);
export default __webpack_public_path__ + "static/media/picto-add.4e574fee9ab71eca76b1a2f48ce3f01c.svg";
export { ForwardRef as ReactComponent };